import { useState, useEffect } from 'react';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';

const hadiths = [
    {
        text: "Le meilleur d'entre vous est celui qui apprend le Coran et l'enseigne.",
        source: "Bukhari"
    },
    {
        text: "Les actes ne valent que par les intentions.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Celui qui jeûne le Ramadan avec foi et espérance de la récompense, ses péchés passés lui seront pardonnés.",
        source: "Bukhari & Muslim"
    },
    {
        text: "La prière est la lumière du croyant.",
        source: "Muslim"
    },
    {
        text: "Craignez Allah où que vous soyez, faites suivre la mauvaise action par une bonne qui l'effacera, et comportez-vous avec les gens de belle manière.",
        source: "Tirmidhi"
    },
    {
        text: "L'homme fort n'est pas celui qui terrasse ses adversaires, mais celui qui se maîtrise lors de la colère.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Nul d'entre vous ne sera véritablement croyant tant qu'il n'aimera pas pour son frère ce qu'il aime pour lui-même.",
        source: "Bukhari & Muslim"
    },
    {
        text: "La propreté est la moitié de la foi.",
        source: "Muslim"
    },
    {
        text: "Celui qui croit en Allah et au Jour dernier, qu'il dise du bien ou qu'il se taise.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Le sourire que tu adresses à ton frère est une aumône.",
        source: "Tirmidhi"
    },
    {
        text: "Allah est Beau et Il aime la beauté.",
        source: "Muslim"
    },
    {
        text: "La patience est une lumière.",
        source: "Muslim"
    },
    {
        text: "Celui qui emprunte un chemin à la recherche d'une science, Allah lui facilite un chemin vers le Paradis.",
        source: "Muslim"
    },
    {
        text: "Le jeûne est un bouclier.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Mangez le Suhoor, car il y a une bénédiction dans le Suhoor.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Lorsque le Ramadan arrive, les portes du Paradis sont ouvertes, les portes de l'Enfer sont fermées et les diables sont enchaînés.",
        source: "Bukhari & Muslim"
    },
    {
        text: "La meilleure aumône est celle donnée pendant le Ramadan.",
        source: "Tirmidhi"
    },
    {
        text: "Celui qui nourrit un jeûneur pour la rupture du jeûne aura la même récompense que lui, sans que cela ne diminue en rien la récompense du jeûneur.",
        source: "Tirmidhi"
    },
    {
        text: "Cherchez la Nuit du Destin (Laylat al-Qadr) dans les dix dernières nuits impaires du Ramadan.",
        source: "Bukhari"
    },
    {
        text: "Une Omra pendant le Ramadan équivaut à un Hajj avec moi.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Le croyant qui se mêle aux gens et supporte leur tort a plus de mérite que celui qui ne se mêle pas aux gens et ne supporte pas leur tort.",
        source: "Tirmidhi"
    },
    {
        text: "La pudeur ne vient qu'avec le bien.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Ne vous mettez pas en colère.",
        source: "Bukhari"
    },
    {
        text: "Aimez pour les gens ce que vous aimez pour vous-mêmes.",
        source: "Ahmad"
    },
    {
        text: "Le meilleur des hommes est celui qui est le plus utile aux hommes.",
        source: "Tabarani"
    },
    {
        text: "La douceur n'est jamais présente dans une chose sans l'embellir, et elle n'est jamais absente d'une chose sans l'enlaidir.",
        source: "Muslim"
    },
    {
        text: "Celui qui ne remercie pas les gens ne remercie pas Allah.",
        source: "Abu Dawud"
    },
    {
        text: "L'injustice sera des ténèbres le Jour de la Résurrection.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Craignez l'invocation de l'opprimé, car il n'y a pas de voile entre elle et Allah.",
        source: "Bukhari & Muslim"
    },
    {
        text: "Le monde d'ici-bas est une prison pour le croyant et un paradis pour le mécréant.",
        source: "Muslim"
    }
];

const HadithOfTheDay = () => {
    const [hadith, setHadith] = useState(null);

    useEffect(() => {
        // Select hadith based on day of month (1-30)
        // Use modulo to handle months with 31 days or if array length changes
        const dayOfMonth = new Date().getDate();
        const index = (dayOfMonth - 1) % hadiths.length;
        setHadith(hadiths[index]);
    }, []);

    if (!hadith) return null;

    return (
        <div className="hadith-container">
            <h3>Hadith du Jour</h3>
            <div className="hadith-content">
                <FaQuoteLeft className="quote-icon left" />
                <p className="hadith-text">{hadith.text}</p>
                <FaQuoteRight className="quote-icon right" />
            </div>
            <p className="hadith-source">— {hadith.source}</p>
        </div>
    );
};

export default HadithOfTheDay;
